export default __webpack_public_path__ + "static/media/photo--sm--kara8.589c3aac.jpg";